import React from "react";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {ButtonLinkStyle} from "../../../../Components/Inputs";
import {aphCatalogQueueModel} from "./aphQueueFactory";
import {AphQueueItem} from "./AphQueueItem";
import {getTotalCost} from "./aphQueueUtility";
import {GridCell} from "../../../../Components/Grid";

interface AphQueueListProps {
    aphQueue: Record<string, any>[];
    handleDeselectAll?: () => void;
    handleRemoveFromQueue: (id: string) => void;
    handleSelectAll?: () => void;
    handleSelectedItemsChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isPendingQueue?: boolean;
    selectedItems?: Set<string>;
}

export const AphQueueList = ({
                                 aphQueue,
                                 handleDeselectAll,
                                 handleRemoveFromQueue,
                                 handleSelectAll,
                                 handleSelectedItemsChange,
                                 isPendingQueue = true,
                                 selectedItems,
                             }: AphQueueListProps) => {

    const isAphQueueEmpty = isArrayNullOrEmpty(aphQueue);

    return <>
        <header>
            <h2> {isPendingQueue ? `Pending` : `Processing`}</h2>
        </header>
        {
            isPendingQueue && !isAphQueueEmpty &&
            <GridCell className={`h3 align-right`}>
                {
                    <p className={`text-muted`}>Total Cost: {getTotalCost(aphQueue)}</p>
                }
            </GridCell>
        }
        {
            !isAphQueueEmpty && handleSelectAll && handleDeselectAll &&
            <>
                <ButtonLinkStyle isCollapsed onClick={handleSelectAll} name={`btnSelectAll`}
                                 label={`Select All`}/> /&nbsp;
                <ButtonLinkStyle isCollapsed onClick={handleDeselectAll} name={`btnDeselectAll`}
                                 label={`Deselect All`}/>
            </>
        }
        {
            !isAphQueueEmpty && aphQueue &&
            aphQueue.map((aphQueuedItem: Record<string, any>) => {

                const {aphCatalogItem, aphQueueItemId} = aphQueuedItem;
                const queueModel = aphCatalogQueueModel({...aphCatalogItem, ...aphQueuedItem});
                const handleDelete = () => handleRemoveFromQueue(aphQueueItemId);
                const isSelected = selectedItems?.has(aphQueueItemId);

                return <AphQueueItem
                    key={aphQueueItemId}
                    {...queueModel}
                    aphCatalogItemId={String(queueModel.aphCatalogItemId || '')}
                    aphQueueItemId={String(aphQueueItemId || '')}
                    title={String(queueModel.title || '')}
                    details={String(queueModel.details || '')}
                    handleDelete={handleDelete}
                    handleSelectedItemsChange={handleSelectedItemsChange}
                    isPendingQueue={isPendingQueue}
                    isSelected={isSelected}
                />;
            })
        }
        {
            isAphQueueEmpty &&
            <p className={`text-center`}>No results.</p>
        }
        <br/>
        <br/>
    </>;
};

